/* ft-pfand-sync.js (05.10.2026, Sitzung Webshop, Ladezeit der Produktseite): Skript aus snippets/ft-pfand-sync ausgelagert, damit der
   Browser es zwischenspeichert. Läuft mit defer nach dem Aufbau der Seite, vor DOMContentLoaded; alle Aufrufer prüfen typeof zur
   Aufrufzeit (Warenkorb-Seite wartet mit Wiederholung). Beschreibung und Historie stehen weiter im Snippet. */
(function () {
  var VID = window.ftPfandVid || 0;  /* Wert aus snippets/ft-pfand-sync (Liquid) */
  var RX  = /^(TLN|TLG|TLNK|TLGK|TLNS|TLGS)-/i;
  /* 05.10.2026 (Teamleitung, Punkt 5 der Ja-Liste für Pascal): Nur der Text der Zeilen-Eigenschaft, die die Kasse unter
     der Pfand-Position zeigt. Vorher „Wird bei Altteil-Rückgabe erstattet“; Pascals Regel vom 01.10.: Erstattung erst nach
     Eingang und Prüfung. Gelesen wird der Text nirgends, die Pfand-Zeile erkennt der Abgleich an der Varianten-ID (VID).
     Gilt für neu angelegte Pfand-Zeilen, bestehende Warenkörbe behalten den alten Text. */
  var EIGENSCHAFT = { 'Altteilpfand': 'Erstattung nach Eingang und Prüfung des Altteils' };
  var KOPF = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var FRIST_MS = 10000;
  /* 05.10.2026 (Teamleitung, Durchgang Marketing Nr. 2 und 7b; Pascal: „es kann passieren dass pfand nicht mit geladen
     wird“): Scheiterte ein Warenkorb-Aufruf (Drossel 429, Serverfehler, Netz weg, Frist), lief der Abgleich bisher still ins
     Leere. Jetzt: einmal nach kurzer Pause wiederholen (Retry-After von Shopify, 0,8 bis 3 s, sonst 1,5 s); scheitert es
     wieder, sichtbarer Hinweis „Bitte Seite neu laden“ (#ft-pfand-hinweis). Ist der Korb dann wahrscheinlich falsch
     (Abweichung erkannt, oder Pfand vor dem Einlegen nicht gesetzt), zusätzlich window.ftPfandStatus.fehler = true, damit
     die Kassen-Prüfung im Warenkorb nicht ohne Abgleich weiterlässt (siehe fehlerMelden). Klappt ein späterer Abgleich,
     verschwindet der Hinweis.
     Andere 4xx-Antworten werden nicht wiederholt (dort hilft kein zweiter Versuch). */
  var WIEDERHOLEN_MS = 1500;
  window.ftPfandStatus = window.ftPfandStatus || { fehler: false };

  /* Warteschlange: Ein Auftrag startet erst, wenn der vorige fertig ist, auch
     wenn der vorige gescheitert ist. */
  var kette = Promise.resolve();
  function einreihen(auftrag) {
    var p = kette.then(function () { return auftrag(); });
    kette = p.then(function () {}, function () {});
    return p;
  }
  window.ftCartQueue = einreihen;

  /* Hängt ein Aufruf, darf er die Warteschlange nicht für immer blockieren. */
  function mitFrist(p, ms) {
    return new Promise(function (erfuellt, abgelehnt) {
      var t = setTimeout(function () { abgelehnt(new Error('Frist abgelaufen')); }, ms);
      p.then(function (w) { clearTimeout(t); erfuellt(w); },
             function (f) { clearTimeout(t); abgelehnt(f); });
    });
  }
  function pause(ms) { return new Promise(function (weiter) { setTimeout(weiter, ms); }); }
  /* Fehler mit Status und Wartezeit, damit mitWiederholung entscheiden kann. */
  function antwortFehler(name, r) {
    var f = new Error(name + ' ' + r.status);
    f.status = r.status;
    var sek = parseFloat(r.headers.get('Retry-After'));
    if (sek > 0) { f.warte = Math.min(3000, Math.max(800, sek * 1000)); }
    return f;
  }
  /* Einmal wiederholen bei 429, 5xx, Netzfehler und abgelaufener Frist; andere 4xx sofort weitergeben. */
  function mitWiederholung(versuch) {
    return versuch().then(null, function (f) {
      if (f && f.status && f.status < 500 && f.status !== 429) { throw f; }
      return pause((f && f.warte) || WIEDERHOLEN_MS).then(versuch);
    });
  }
  function lesen() {
    return mitWiederholung(function () {
      return mitFrist(fetch('/cart.js?_fd=0', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw antwortFehler('cart.js', r); return r.json(); }), FRIST_MS);
    });
  }
  function senden(url, daten) {
    return mitWiederholung(function () {
      return mitFrist(fetch(url, { method: 'POST', credentials: 'same-origin', headers: KOPF, body: JSON.stringify(daten) })
        .then(function (r) { if (!r.ok) throw antwortFehler(url, r); return r.json(); }), FRIST_MS);
    });
  }

  /* Sichtbarer Hinweis, wenn der Abgleich auch nach der Wiederholung scheitert. Nie still nichts tun. */
  function hinweisZeigen() {
    /* Auf der Warenkorbseite trägt die Pfand-Warnung im Summenblock (#ft-cart-pfandwarnung) denselben Hinweis, dann nicht doppelt. */
    if (!document.body || document.getElementById('ft-pfand-hinweis') || document.getElementById('ft-cart-pfandwarnung')) { return; }
    var box = document.createElement('div');
    box.id = 'ft-pfand-hinweis';
    box.className = 'ft-pfand-hinweis';
    box.setAttribute('role', 'alert');
    box.innerHTML = '<p class="ft-pfand-hinweis-text"><strong>Das Altteilpfand konnte gerade nicht abgeglichen werden.</strong> '
      + 'Bitte laden Sie die Seite neu, damit Pfand und Summe stimmen.</p>'
      + '<div class="ft-pfand-hinweis-knoepfe"><button type="button" class="ft-pfand-hinweis-neu">Seite neu laden</button>'
      + '<a class="ft-pfand-hinweis-tel" href="tel:+491748416161">Oder anrufen: +49 174 8416161</a></div>'
      + '<button type="button" class="ft-pfand-hinweis-zu" aria-label="Hinweis schließen">'
      + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
    box.querySelector('.ft-pfand-hinweis-neu').addEventListener('click', function () { location.reload(); });
    box.querySelector('.ft-pfand-hinweis-zu').addEventListener('click', function () { box.remove(); });
    document.body.appendChild(box);
  }
  /* sperren = true: Der Korb ist wahrscheinlich falsch (Abweichung erkannt und nicht behoben, oder Pfand konnte vor dem
     Einlegen eines Artikels nicht gesetzt werden). Dann lässt die Kassen-Prüfung im Warenkorb nicht ohne Abgleich weiter.
     sperren = false: Nur das Lesen scheiterte, der Stand ist unbekannt; Hinweis ja, Kasse wie bisher nach der
     Liquid-Sperre vom Seitenaufbau (sonst bei Dauerdrossel nie zur Kasse). */
  function fehlerMelden(sperren) {
    if (sperren) { window.ftPfandStatus.fehler = true; }
    try { document.dispatchEvent(new CustomEvent('ft-pfand-fehler')); } catch (e) { /* alter Browser */ }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hinweisZeigen);
    } else { hinweisZeigen(); }
  }
  function inOrdnung() {
    window.ftPfandStatus.fehler = false;
    var box = document.getElementById('ft-pfand-hinweis');
    if (box) { box.remove(); }
  }
  function zaehlen(cart) {
    var z = { soll: 0, ist: 0, zeilen: [] };
    ((cart && cart.items) || []).forEach(function (it) {
      if (it.variant_id === VID) { z.ist += it.quantity; z.zeilen.push(it.key); return; }
      if (RX.test(String(it.sku || ''))) { z.soll += it.quantity; }
    });
    return z;
  }
  function vermerkText(z) {
    return new Date().toISOString().slice(0, 16) + ' ist=' + z.ist + ' soll=' + z.soll +
      ' seite=' + location.pathname;
  }

  /* Pfandmenge auf `ziel` setzen. Liegt schon eine Pfand-Zeile im Korb: EIN Aufruf
     /cart/update.js mit Menge und Vermerk zusammen (liegen mehrere Pfand-Zeilen
     im Korb, bekommt die erste die Menge und die übrigen 0). Fehlt die Zeile:
     /cart/add.js mit der Zeilen-Eigenschaft, danach der Vermerk, nacheinander. */
  function setzen(z, ziel, vermerk) {
    var attr = vermerk ? { ft_pfand_korrektur: vermerk } : null;
    if (!z.zeilen.length) {
      if (ziel < 1) { return attr ? senden('/cart/update.js?_fd=0', { attributes: attr }) : Promise.resolve(null); }
      return senden('/cart/add.js?_fd=0', { id: VID, quantity: ziel, properties: EIGENSCHAFT })
        .then(function () { return attr ? senden('/cart/update.js?_fd=0', { attributes: attr }) : null; });
    }
    var updates = {};
    z.zeilen.forEach(function (key, i) { updates[key] = (i === 0) ? ziel : 0; });
    var daten = { updates: updates };
    if (attr) { daten.attributes = attr; }
    return senden('/cart/update.js?_fd=0', daten);
  }
  /* Zweiter Weg, falls der erste nicht gegriffen hat: /cart/change.js Zeile für
     Zeile, nacheinander. /cart/change.js braucht den Line-Item-KEY; die
     Varianten-ID liefert hier 400. */
  function setzenEinzeln(z, ziel) {
    if (!z.zeilen.length) {
      return ziel > 0 ? senden('/cart/add.js?_fd=0', { id: VID, quantity: ziel, properties: EIGENSCHAFT }) : Promise.resolve(null);
    }
    var schritt = Promise.resolve(null);
    z.zeilen.forEach(function (key, i) {
      schritt = schritt.then(function () {
        return senden('/cart/change.js?_fd=0', { id: key, quantity: (i === 0) ? ziel : 0 });
      });
    });
    return schritt;
  }
  function stand(z, geaendert) {
    return { ok: z.soll === z.ist, geaendert: geaendert, ist: z.ist, soll: z.soll };
  }

  /* Abgleich: lesen, bei Abweichung setzen, NACHLESEN, notfalls zweiter Weg,
     wieder nachlesen. Ergebnis { ok, geaendert, ist, soll }; ok heißt
     „nachgelesen und richtig". Nur innerhalb der Warteschlange aufrufen. */
  function abgleichen() {
    return lesen().then(function (cart) {
      var z = zaehlen(cart);
      if (z.soll === z.ist) { return stand(z, false); }
      return setzen(z, z.soll, vermerkText(z))
        .then(null, function () { return null; })
        .then(lesen)
        .then(function (cart2) {
          var z2 = zaehlen(cart2);
          if (z2.soll === z2.ist) { return stand(z2, true); }
          return setzenEinzeln(z2, z2.soll)
            .then(null, function () { return null; })
            .then(lesen)
            .then(function (cart3) { return stand(zaehlen(cart3), true); });
        })
        /* 05.10.2026: Eine Abweichung war erkannt; scheitert danach das Nachlesen, ist der Korb vermutlich falsch. */
        .then(null, function (f) { if (f) { f.abweichung = true; } throw f; });
    });
  }

  /* Pfand vor dem Einlegen eines Artikels auf den Sollwert NACH dem Einlegen
     setzen: pfandpflichtige Stücke im Korb + n. Nie ist + n. Nur innerhalb
     der Warteschlange aufrufen. */
  function vorabIntern(n) {
    return lesen().then(function (cart) {
      var z = zaehlen(cart);
      var ziel = z.soll + n;
      if (z.ist === ziel) { return true; }
      return setzen(z, ziel, null).then(function () { return true; });
    });
  }

  /* Ergebnis mit Einzelheiten, für die Prüfung beim Klick auf „Zur Kasse".
     05.10.2026: Stimmt es nachgelesen, verschwindet ein alter Hinweis; stimmt es auch nach beiden Korrekturwegen nicht
     oder scheitert das Lesen zweimal, erscheint der Hinweis „Bitte Seite neu laden“. */
  /* 05.10.2026: Abweichungen an GA4 melden (window.ftKorbFehlerMelden aus snippets/ft-warenkorb, nur mit Einwilligung, ohne
     Kundendaten): „pfand_korrigiert“ = Pfand stimmte nicht und ist jetzt richtig, „pfand_abgleich“ = blieb falsch. */
  function analyseMelden(weg, d) {
    if (typeof window.ftKorbFehlerMelden === 'function') { window.ftKorbFehlerMelden(weg, d); }
  }
  window.ftPfandPruefen = function (optionen) {
    if (!VID) { return Promise.resolve({ ok: true, geaendert: false, ist: 0, soll: 0 }); }
    var leise = !!(optionen && optionen.leise);
    return einreihen(abgleichen).then(function (e) {
      if (e && e.ok) { inOrdnung(); } else { fehlerMelden(true); }
      if (e && !e.ok) { analyseMelden('pfand_abgleich', { fehler: 'nicht behoben: ist ' + e.ist + ', soll ' + e.soll, mitPfand: true }); }
      else if (e && e.geaendert) { analyseMelden('pfand_korrigiert', { fehler: 'korrigiert auf ' + e.soll, mitPfand: true }); }
      return e;
    }, function (f) {
      /* 05.10.2026: leise (Abgleich nach ftInDenWarenkorb, der Korb wurde in einem Stück geschrieben): scheitert nur das
         Lesen, kein Hinweis. Eine erkannte, nicht behobene Abweichung meldet er immer. */
      var abweichung = !!(f && f.abweichung);
      if (abweichung || !leise) { fehlerMelden(abweichung); }
      if (abweichung) { analyseMelden('pfand_abgleich', { status: f.status, fehler: 'Abweichung erkannt, Nachlesen gescheitert', mitPfand: true }); }
      throw f;
    });
  };
  /* 05.10.2026: Gemeinsame Regel für snippets/ft-warenkorb (Grundbau), damit Pfand-Variante, SKU-Regel und Text der
     Zeilen-Eigenschaft nur hier stehen. */
  window.ftPfandRegel = { VID: VID, RX: RX, EIGENSCHAFT: EIGENSCHAFT };

  /* Rückgabe wie vor dem 24.09.: true = es wurde etwas geändert UND es stimmt
     nachgelesen. false = nichts zu tun ODER es hat nicht geklappt; die
     Warenkorbseite unterscheidet das über ihre Pfand-Warnung und die
     6-Sekunden-Frist. */
  window.ftPfandSync = function () {
    return window.ftPfandPruefen().then(function (e) {
      return !!(e && e.ok && e.geaendert);
    }, function () { return false; });
  };

  /* 18.08.2026 - Altteilpfand VOR dem Produkt einlegen.
     Shopify sortiert den ZULETZT eingelegten Artikel nach OBEN. Weil
     ftPfandSync das Pfand NACHtraeglich bucht, stand im Warenkorb und im
     Checkout die 119-EUR-Gebuehr an Position 1 und der gekaufte Turbolader
     darunter - der Kunde las "2 Artikel" und zweifelte an seiner Bestellung.
     Nachgemessen: Turbo->Pfand ergibt PFAND oben, Pfand->Turbo ergibt TURBO
     oben. Also wird das Pfand vorgebucht und das Produkt danach eingelegt.
     NICHT durch nachtraegliches Umsortieren ersetzen: /cart/change.js
     sortiert nicht um, und Entfernen-und-neu-Anlegen verliert die
     Line-Item-Properties.
     Sicherheitsnetz: Schlaegt das Einlegen des Produkts danach fehl, ruft
     der Aufrufer ftPfandSync() - das SETZT die Menge auf die Zahl der
     pfandpflichtigen Artikel und raeumt den Ueberhang sofort weg. */
  window.ftPfandVorab = function (menge) {
    if (!VID) { return Promise.resolve(false); }
    var n = parseInt(menge, 10) || 0;
    if (n < 1) { return Promise.resolve(false); }
    return einreihen(function () { return vorabIntern(n); })
      .then(function (w) { inOrdnung(); return w; }, function () { fehlerMelden(true); return false; });
  };

  /* Pfand vorbuchen UND Artikel einlegen als EIN Auftrag. `einlegen` ist eine
     Funktion, die die fetch-Promise des /cart/add.js-Aufrufs liefert; das
     Ergebnis ist deren Response. menge = 0 heißt: Artikel ohne Pfand. */
  window.ftPfandMitArtikel = function (menge, einlegen) {
    var n = parseInt(menge, 10) || 0;
    return einreihen(function () {
      /* 05.10.2026: Scheitert das Vorbuchen auch nach der Wiederholung, wird der Artikel wie bisher trotzdem eingelegt
         (Kassen-Sperre im Warenkorb als Sicherung), aber der Hinweis erscheint. */
      var vorab = (VID && n > 0)
        ? vorabIntern(n).then(function (w) { inOrdnung(); return w; }, function () { fehlerMelden(true); return false; })
        : Promise.resolve(false);
      return vorab.then(function () { return mitFrist(Promise.resolve(einlegen()), 15000); });
    });
  };
})();
